// extracted by mini-css-extract-plugin
export default {"Recipe":"Recipe_Recipe__Kz0g+"};